"use strict";
// DO NOT EDIT. Generated by gitlab.com/accumulatenetwork/accumulate/tools/cmd/gen-types.
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortOffset = exports.NodeType = void 0;
/* eslint-disable @typescript-eslint/no-namespace */
var NodeType;
(function (NodeType) {
    /** Validator . */
    NodeType[NodeType["Validator"] = 1] = "Validator";
    /** Follower . */
    NodeType[NodeType["Follower"] = 2] = "Follower";
})(NodeType = exports.NodeType || (exports.NodeType = {}));
/** @ignore */
(function (NodeType) {
    function fromObject(obj) {
        if (typeof obj === "number")
            return obj;
        return byName(obj);
    }
    NodeType.fromObject = fromObject;
    function byName(name) {
        switch (name.toLowerCase()) {
            case "validator":
                return NodeType.Validator;
            case "follower":
                return NodeType.Follower;
            default:
                throw new Error(`Unknown NodeType '${name}'`);
        }
    }
    NodeType.byName = byName;
    function getName(v) {
        switch (v) {
            case NodeType.Validator:
                return "validator";
            case NodeType.Follower:
                return "follower";
            default:
                throw new Error(`Unknown NodeType ${v}`);
        }
    }
    NodeType.getName = getName;
})(NodeType = exports.NodeType || (exports.NodeType = {}));
var PortOffset;
(function (PortOffset) {
    /** TendermintP2P . */
    PortOffset[PortOffset["TendermintP2P"] = 0] = "TendermintP2P";
    /** TendermintRpc . */
    PortOffset[PortOffset["TendermintRpc"] = 1] = "TendermintRpc";
    /** AccumulateP2P . */
    PortOffset[PortOffset["AccumulateP2P"] = 2] = "AccumulateP2P";
    /** Prometheus . */
    PortOffset[PortOffset["Prometheus"] = 3] = "Prometheus";
    /** AccumulateApi . */
    PortOffset[PortOffset["AccumulateApi"] = 4] = "AccumulateApi";
})(PortOffset = exports.PortOffset || (exports.PortOffset = {}));
/** @ignore */
(function (PortOffset) {
    function fromObject(obj) {
        if (typeof obj === "number")
            return obj;
        return byName(obj);
    }
    PortOffset.fromObject = fromObject;
    function byName(name) {
        switch (name.toLowerCase()) {
            case "tendermintp2p":
                return PortOffset.TendermintP2P;
            case "tendermintrpc":
                return PortOffset.TendermintRpc;
            case "accumulatep2p":
                return PortOffset.AccumulateP2P;
            case "prometheus":
                return PortOffset.Prometheus;
            case "accumulateapi":
                return PortOffset.AccumulateApi;
            default:
                throw new Error(`Unknown PortOffset '${name}'`);
        }
    }
    PortOffset.byName = byName;
    function getName(v) {
        switch (v) {
            case PortOffset.TendermintP2P:
                return "tendermintP2P";
            case PortOffset.TendermintRpc:
                return "tendermintRpc";
            case PortOffset.AccumulateP2P:
                return "accumulateP2P";
            case PortOffset.Prometheus:
                return "prometheus";
            case PortOffset.AccumulateApi:
                return "accumulateApi";
            default:
                throw new Error(`Unknown PortOffset ${v}`);
        }
    }
    PortOffset.getName = getName;
})(PortOffset = exports.PortOffset || (exports.PortOffset = {}));
//# sourceMappingURL=config_enums_gen.js.map